const allowReuse = (AllFormStatuses, form_type) => {
  const formStatusNameMap = {
    9141: "PWD",
    "790A": "H2A",
    "9142A": "H2A",
    "9142B": "H2B",
    9035: "LCA",
    9089: "PERM",
  };
  const formStatusName = formStatusNameMap[form_type];
  const formStatus = AllFormStatuses?.find(
    (fs) => fs.formType === formStatusName
  );

  return formStatus?.isReusable;
};

export default allowReuse;
